import { getAuthenticatedApiClient } from '../api-client';
import { useQuery } from 'react-query';

const getPOICategories = () =>
  getAuthenticatedApiClient()
    .getPointOfInterestCategories()
    .then((res) => res.data);

export const useGetPOICategories = () => useQuery('point-of-interest-categories', getPOICategories);
